import { makeStyles } from "@material-ui/core"

import {
	SIDEBAR_EXPANDED_WIDTH_IN_PIXELS,
	SIDEBAR_COLLAPSED_WIDTH_IN_PIXELS
} from "@/pages/Attendance/styles"

const SIDEBAR_TRANSITION_DURATION_IN_SECONDS = 0.18

type SidebarDrawerOffsetProps = {
	isCollapsed: boolean
}

const useSidebarDrawerStyles = makeStyles({
	drawerPaperOffset: (props: SidebarDrawerOffsetProps) => ({
		left: props.isCollapsed ? SIDEBAR_COLLAPSED_WIDTH_IN_PIXELS : SIDEBAR_EXPANDED_WIDTH_IN_PIXELS,
		transition: `left ${SIDEBAR_TRANSITION_DURATION_IN_SECONDS}s`
	})
})

export default useSidebarDrawerStyles
